import { daysUntilNow, getFormattedTime } from 'Helpers/dates';

export const getCarDetails = item => {
    if (!item) {
        return null;
    }
    const make = item.parameters.find(({ key }) => key === 'make');
    const model = item.parameters.find(({ key }) => key === 'model');
    const variant = item.parameters.find(({ key }) => key === 'variant');
    const year = item.parameters.find(({ key }) => key === 'year');
    const mileage = item.parameters.find(({ key }) => (key === 'mileage') || (key === 'km_driven'));

    return {
        model: [make && make.value_name, model && model.value_name].filter(a => a).join(' '),
        variant: [variant && variant.value_name, year && year.value_name].filter(a => a).join(', '),
        driven: mileage && `${mileage.value_name.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} Km`
    };
};

export const getMeetingDate = (date, lang) => {
    const year = date?.split('-')[0];
    const month = date && parseInt(date?.split('-')[1], 10) - 1;
    const day = date?.split('-')[2];
    const meetingDateObj = new Date();

    if (date) {
        meetingDateObj.setFullYear(year, month, day);
    }
    const meetingDate = meetingDateObj.toLocaleDateString(lang, { day: 'numeric' });
    let meetingMonth = meetingDateObj.toLocaleDateString(lang, { month: 'short' });
    const meetingYear = meetingDateObj.toLocaleDateString(lang, { year: 'numeric' });
    let meetingWeekday = meetingDateObj.toLocaleDateString(lang, { weekday: 'short' });

    meetingMonth = `${meetingMonth.charAt(0).toUpperCase()}${meetingMonth.slice(1)}`;
    meetingWeekday = `${meetingWeekday.charAt(0).toUpperCase()}${meetingWeekday.slice(1)}`;

    const dateString = date && `${meetingWeekday}, ${meetingDate} ${meetingMonth} ${meetingYear}`;
    const daysLeft = date && daysUntilNow(date, true);

    return {
        dateString,
        meetingDate,
        meetingMonth,
        meetingWeekday,
        daysLeft
    };
};

export const getFieldName = isStoreVisitEnabled => (isStoreVisitEnabled ? 'store_visit' : 'store_test_drive');

export const getTimeStampString = (date, time) => `${date } ${ time}`;

export const getChosenOption = (isStoreVisitEnabled, timestamp) => (isStoreVisitEnabled ? timestamp : null);

export const getBookingFormattedTime = (threadMeeting, operatingDetails, showroom_address, isStoreVisitEnabled) => {
    let formattedStartTime = '';

    if (threadMeeting?.time) {
        formattedStartTime = threadMeeting?.time; // already in 12 hour format
    }

    if (!formattedStartTime && !isStoreVisitEnabled) {
        const startTime = operatingDetails?.[0]?.startTime || showroom_address?.operatingdetails?.[0]?.startTime;

        formattedStartTime = `${getFormattedTime(startTime, true)}`;
    }

    let formattedEndTime = '';

    if (threadMeeting?.endTime) {
        formattedEndTime = ` - ${threadMeeting?.endTime}`; // already in 12 hour format
    }

    if (!threadMeeting?.endTime && !isStoreVisitEnabled) {
        const endTime = operatingDetails?.[0]?.endTime || showroom_address?.operatingdetails?.[0]?.endTime;

        formattedEndTime = ` - ${getFormattedTime(endTime, true)}`;
    }

    return { formattedStartTime, formattedEndTime };
};
